import { render, staticRenderFns } from "./type-list.vue?vue&type=template&id=4aa4ed28&scoped=true&"
import script from "./type-list.vue?vue&type=script&lang=js&"
export * from "./type-list.vue?vue&type=script&lang=js&"
import style0 from "./type-list.vue?vue&type=style&index=0&id=4aa4ed28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4ed28",
  null
  
)

export default component.exports